import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { selectionProcessesAdmin } from '@/services/selectionProcesses';
import { PATHS } from '@/routes/paths';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { DashboardContent } from '@/layouts/dashboard';

export default function SelectionProcessesList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    selectionProcessesAdmin
      .list()
      .then(res => setItems(res.data || []))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="p-4">Carregando...</p>;

  const breadcrumbs = {
    title: 'Inscrições',
    nav: [
      {
        name: 'Seletivos',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <div className="filter-bar">
        <Button onClick={() => navigate(PATHS.ADMIN_SELETIVO.NEW)}>Novo seletivo</Button>
      </div>
      <div className="grid gap-3">
        {items.map(p => {
          const a = p.attributes;
          return (
            <Card
              key={p.id}
              className="p-4"
            >
              <div className="flex items-center justify-between">
                <Link
                  to={PATHS.ADMIN_SELETIVO.DETAIL(p.id)}
                  className="font-semibold"
                >
                  {a.name}
                </Link>
                <Badge>{a.status}</Badge>
              </div>
              <p className="text-sm text-gray-600">
                /{a.slug} • {a.registrations_count} inscritos • até {new Date(a.ends_at).toLocaleString('pt-BR')}
              </p>
            </Card>
          );
        })}
        {items.length === 0 && <p className="text-gray-500">Nenhum seletivo criado ainda.</p>}
      </div>
    </DashboardContent>
  );
}
